import { render, staticRenderFns } from "./OverviewBright.vue?vue&type=template&id=27696509"
import script from "./OverviewBright.vue?vue&type=script&lang=js"
export * from "./OverviewBright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports